import type { ReactElement } from 'react';

import type { ResolvedMemberName } from './utils';

interface NameOrSkeletonProps {
  readonly resolved: ResolvedMemberName;
  readonly className?: string;
  readonly skeletonWidthClass?: string;
}

/**
 * Renders a resolved user name, or a pulsing skeleton bar while the directory
 * join is still pending. Shared by the panel row, primary section, and
 * member-list row so the raw `user_id` GUID never leaks into the UI on the
 * first render after data loads.
 */
export function NameOrSkeleton({
  resolved,
  className,
  skeletonWidthClass = 'w-32',
}: NameOrSkeletonProps): ReactElement {
  if (resolved.status === 'pending') {
    return (
      <span
        aria-hidden="true"
        className={`inline-block h-3.5 ${skeletonWidthClass} rounded bg-muted align-middle animate-pulse`}
      />
    );
  }
  return <span className={className}>{resolved.name}</span>;
}
